var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 52.952 33.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M45.13,1.179a39.354,39.354,0,0,0-8.3-5.5,23.9,23.9,0,0,0-10.354-2.54A23.909,23.909,0,0,0,16.122-4.32a39.377,39.377,0,0,0-8.3,5.5A51.184,51.184,0,0,0,.215,9.147a1.117,1.117,0,0,0,0,1.317,51.15,51.15,0,0,0,7.608,7.968,39.356,39.356,0,0,0,8.3,5.5,23.908,23.908,0,0,0,10.354,2.54,23.914,23.914,0,0,0,10.354-2.54,39.379,39.379,0,0,0,8.3-5.5,51.125,51.125,0,0,0,7.607-7.968,1.115,1.115,0,0,0,0-1.317A51.078,51.078,0,0,0,45.13,1.179ZM26.477,24.238c-6.881,0-13.136-4.066-17.172-7.478A51.567,51.567,0,0,1,2.529,9.806C4.852,6.9,14.807-4.626,26.476-4.626c6.881,0,13.136,4.066,17.172,7.477A51.629,51.629,0,0,1,50.424,9.8C48.1,12.71,38.147,24.239,26.476,24.239Zm0,0",
    transform: "translate(0 6.859)",
    fill: "#009639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M174.649,46.07a11.935,11.935,0,1,0,11.935,11.935A11.935,11.935,0,0,0,174.649,46.07Zm0,21.637a9.7,9.7,0,1,1,9.7-9.7,9.7,9.7,0,0,1-9.7,9.7Zm0,0",
    transform: "translate(-148.173 -41.34)",
    fill: "#009639"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/EyeOpen.b072c22da2fbe8daf1dabe7aee7714b9.svg";
export { ForwardRef as ReactComponent };